<mat-card class="cardWithShadow w-50">
  <mat-card-content >
    <div>
      <mat-card-title>Factorizaciones por factoring</mat-card-title>
    </div>

    <div class="spinner">
      <mat-spinner [diameter]="60" *ngIf="booleanFlagCesionario == true"></mat-spinner>
    </div>

    <div class="table-responsive m-t-30" [class.esconder]="booleanFlagCesionario == true">
      <table
        mat-table
        [dataSource]="dataSource"
        class="w-100"
        matSort
        matSortDirection="asc"
      >
        <!-- Position Column -->
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef           
          >
            Razon Social
          </th>
          <td mat-cell *matCellDef="let element">
            <h6>
              {{ element.name }}
            </h6>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="rut">
          <th
            mat-sort-header
            mat-header-cell
            *matHeaderCellDef
          >
            Rut
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>
              {{ element.rut }}
            </h6>
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="invoiceAmount">
          <th
            mat-sort-header
            mat-header-cell
            *matHeaderCellDef
          >
            Monto Facturas
          </th>
          <td mat-cell *matCellDef="let element">
            <h6>{{ element.invoiceAmount | currency:'CLP':'symbol' }}</h6>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="docs">
          <th
            mat-sort-header
            mat-header-cell
            *matHeaderCellDef
          >
            Documentos
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.docs }}</h6>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <!-- <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">
                No data matching the filter "{{ input.value }}"
              </td>
            </tr> -->
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
  </mat-card-content>

</mat-card>
